import mustache from "mustache";
import { serviceProvider } from "../../../comun/provider/ServiceProvider";
import { fx_createFincaClimaHorarioGrpcService } from "../../../modulos/clima/services/FincaClimaHorarioGrpcService";
import { FincaClimaDataHorarioResponse } from "../../../modulos/clima/response/FincaClimaDataHorarioResponse";
import { _2d } from "../../../utils/numberUtils";
import { ClimaSeccionBase } from "./ClimaSeccionBase";
import template from "./climaSolSueloTemplate.html";

mustache.parse(template);

/** Misma cadencia que `ClimaHorarioStatsRender` (dato de la hora vigente). */
const REFRESH_INTERVAL_MS = 60_000;

let SOL_SUELO_ID = 0;

/** Sección "Tiempo Sol / Temperatura Suelo / Humedad Suelo" de la hora
 *  vigente (Current). Se refresca solo cada minuto (ver `ClimaSeccionBase`). */
export class ClimaSolSueloRender extends ClimaSeccionBase<FincaClimaDataHorarioResponse> {
  private readonly _solSueloId: number;

  constructor() {
    super(REFRESH_INTERVAL_MS);
    SOL_SUELO_ID += 1;
    this._solSueloId = SOL_SUELO_ID;
  }

  render(): string {
    return mustache.render(template, { solSueloId: this._solSueloId });
  }

  protected fetchList(): Promise<FincaClimaDataHorarioResponse[]> {
    const finca = serviceProvider.getFincaSelectedService().getRequired();
    return fx_createFincaClimaHorarioGrpcService(finca.id).getListAsync();
  }

  protected onVigente(current: FincaClimaDataHorarioResponse): void {
    this._setValue("tiempo-sol", `${_2d(current.sunshinetime)} min/h`);
    this._setValue(
      "temperatura-suelo",
      `${_2d(current.soiltemperature0to10cm)} °C`,
    );
    // El campo es porcentaje volumétrico (%), no °C — el mockup mostraba °C
    // por error de copiado.
    this._setValue("humedad-suelo", `${_2d(current.soilmoisture0to10cm)} %`);
  }

  private _setValue(key: string, text: string): void {
    const el = document.getElementById(`css-${key}-${this._solSueloId}`);
    if (el) el.textContent = text;
  }
}
